
import React from 'react';
import { HashRouter, Routes, Route, Navigate } from 'react-router-dom';
import DashboardContent from './components/DashboardContent';
import BoardDetails from './components/BoardDetails';
import StartStopActivity from './components/StartStopActivity';
import MonthlyReport from './components/MonthlyReport';
import TeamsContent from './components/Teams/TeamsContent';
import TeamsTab from './components/Teams/TeamsTab';
import TeamsForms from './components/Teams/TeamsForms';
import Login from './components/Login';
import ViewActivityHistory from './components/ViewActivityHistory';
import LiveFeedExcelView from './components/LiveFeedExcelView';
import MainLayout from './components/MainLayout';
import MembersContent from './components/Member/MembersContent';
import MembersCreate from './components/Member/MembersCreate';
import MembersEdit from './components/Member/MembersEdit';
import DailyTask from './components/DailyTask';
import DataExecuter from './components/DataExecuter';
import ProtectedRoute from './components/ProtectedRoute';
import { isLoggedIn } from "./components/utils/auth";
import Settings from './components/Settings';
import ErrorLogs from './components/ErrorLogs';
//import ProtectedRoute from './components/ProtectedRoute';


function App() {
  return (
    <HashRouter>
      <Routes>

        {/* ROOT */}
        <Route path="/"
          element={
            isLoggedIn()
              ? <Navigate to="/dashboard" replace />
              : <Navigate to="/login" replace />
          }
        />

        {/* LOGIN */}
        <Route path="/login" element={<Login />} />

        {/* 🔐 PROTECTED ROUTES */}
        <Route
          element={
            <ProtectedRoute>
              <MainLayout />
            </ProtectedRoute>
          }
        >
          <Route path="/dashboard" element={<DashboardContent />} />
          <Route path="/StartStopActivity" element={<StartStopActivity />} />
          <Route path="/MonthlyReport" element={<MonthlyReport />} />
          <Route path="/board/:boardId" element={<BoardDetails />} />
          <Route path="/teams" element={<TeamsContent />} />
          <Route path="/teams/create" element={<TeamsForms />} />
          <Route path="/teamsid/:id" element={<TeamsTab />} />
          <Route path="/members" element={<MembersContent />} />
          <Route path="/dailytask" element={<DailyTask />} />
          <Route path="/ViewActivityHistory/:id" element={<ViewActivityHistory />} />
          <Route path="/excelview" element={<LiveFeedExcelView />} />
          <Route path="/Members/Create" element={<MembersCreate />} />
          <Route path="/Member/Edit/:id" element={<MembersEdit />} />
          <Route path="/my-profile" element={<MembersEdit profileMode />} />
          <Route path="/dataexecuter" element={<DataExecuter />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/ErrorLogs" element={<ErrorLogs />} />
        </Route>

        {/* FALLBACK */}
        <Route path="*" element={<Navigate to="/" replace />} />

      </Routes>
    </HashRouter>
  );
}

export default App;